import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    this.openedOnHover = false
    this.sync()
  }

  sync() {
    this.toggleTarget.setAttribute("aria-expanded", String(this.element.open))
  }

  enter(event) {
    if (event.pointerType !== "mouse" || !window.matchMedia("(hover: hover)").matches || this.element.open) return
    this.openedOnHover = true
    this.element.open = true
    this.sync()
  }

  activate(event) {
    // The first mouse click must not close a submenu that hover just opened.
    if (this.openedOnHover && event.detail > 0) event.preventDefault()
    this.openedOnHover = false
  }

  leave(event) {
    if (event.pointerType === "mouse" && !this.element.contains(document.activeElement)) this.reset()
  }

  outside(event) {
    if (!this.element.contains(event.target)) this.reset()
  }

  focusChanged(event) {
    if (!this.element.contains(event.target)) this.reset()
  }

  close(event) {
    if (!this.element.open) return
    event.preventDefault()
    this.reset()
    this.toggleTarget.focus()
  }

  reset() {
    this.element.open = false
    this.openedOnHover = false
    this.sync()
  }

  navigate(event) {
    if (event.target.closest("a")) this.reset()
  }

  disconnect() { this.reset() }
}
